module.exports = __webpack_public_path__ + "static/media/373.3b25abf7.webp";